import { PasswordResetCompletePage } from "./PasswordResetCompletePage";
export default PasswordResetCompletePage;
